import React, { useContext, useState } from "react";
import { LangContext } from "../../context/LangContext";
import Bread from "../../common/Bread";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Loader from "../../common/Loader";
import { Modal } from "@mui/material";
import "./crossborderpayment.scss";

function CrossBorderpayment() {
  const lang = useContext(LangContext);
  const nep = lang.state.np;

  const [modalOpen, setModalOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);

  const breadcrumList = {
    image: "",
    title: nep ? "सीमापार भुक्तानी" : "Cross Border Payment",
    l1: nep ? "होम" : "Home",
    l2: nep ? "सीमापार भुक्तानी" : "Cross Border Payment",
    l3: "",
  };

  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ["crossborder_payment"],
    queryFn: () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/crossborder_payment/all`)
        .then((res) => res.data),
  });

  if (isLoading || isFetching) return <Loader />;
  if (error) return <h3>{error.message}</h3>;

  const crossborderpaymentdata = nep ? data?.items?.np : data?.items?.en;

  const openModal = (item) => {
    setCurrentItem(item);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setCurrentItem(null);
  };

  const firstImage = (item) => {
    if (item.images?.length > 0) return item.images[0];
    return null;
  };

  return (
    <Bread data={breadcrumList}>
      <div className="crossborder-payment">
        <div className="cbp-grid">
          {crossborderpaymentdata?.map((item) => {
            const img = firstImage(item);
            return (
              <div
                className="cbp-card"
                key={item.id}
                onClick={() => openModal(item)}
              >
                <div className="cbp-card-img">
                  {img ? (
                    <>
                      <img
                        src={img.DocPath}
                        alt={img.file_alt || item.Title || ""}
                        loading="lazy"
                      />
                      <div className="cbp-card-overlay">
                        <span className="cbp-card-icon">🔍</span>
                      </div>
                    </>
                  ) : (
                    <div className="cbp-card-placeholder">
                      {item.Title?.charAt(0)}
                    </div>
                  )}
                </div>
                <div className="cbp-card-body">
                  <h3 className="cbp-card-title">{item.Title}</h3>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <Modal open={modalOpen} onClose={closeModal}>
        <div className="cbp-modal">
          <button className="cbp-modal-close" onClick={closeModal}>
            ✕
          </button>
          {currentItem && (
            <div className="cbp-modal-content">
              {currentItem.images?.length > 0 ? (
                <div className="cbp-modal-image">
                  <img
                    src={currentItem.images[0].DocPath}
                    alt={
                      currentItem.images[0].file_alt || currentItem.Title || ""
                    }
                    onLoad={(e) => {
                      const img = e.target;
                      const wrapper = img.closest(".cbp-modal");
                      const maxH = window.innerHeight * 0.75;
                      const maxW = window.innerWidth * 0.85;
                      const natW = img.naturalWidth;
                      const natH = img.naturalHeight;
                      let dispW = natW;
                      let dispH = natH;
                      if (dispW > maxW) {
                        dispH = dispH * (maxW / dispW);
                        dispW = maxW;
                      }
                      if (dispH > maxH) {
                        dispW = dispW * (maxH / dispH);
                        dispH = maxH;
                      }
                      wrapper.style.setProperty("--cbp-img-w", dispW + "px");
                      wrapper.style.setProperty("--cbp-img-h", dispH + "px");
                    }}
                  />
                </div>
              ) : (
                <div className="cbp-modal-placeholder">
                  {currentItem.Title?.charAt(0)}
                </div>
              )}
              <div className="cbp-modal-info">
                <h2 className="cbp-modal-title">{currentItem.Title}</h2>
                {currentItem.Description && (
                  <div
                    className="cbp-modal-desc"
                    dangerouslySetInnerHTML={{
                      __html: currentItem.Description,
                    }}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </Modal>
    </Bread>
  );
}

export default CrossBorderpayment;
